module.exports = __webpack_public_path__ + "img/objects-links-bg-2.058b1ac.jpeg";